"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles"));
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ReadMoreText = props => {
  var {
    text,
    textClassName,
    detailText,
    lines
  } = props;
  var classes = (0, _styles.default)();
  var [showMore, setShowMore] = (0, _react.useState)(false);
  var contentRef = (0, _react.useRef)();
  function isExceedingMaxLines() {
    return contentRef.current ? (0, _utils.getContentLines)(contentRef.current, document) > lines : false;
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(textClassName, " ").concat(!showMore && classes.ellipsis),
    ref: contentRef,
    style: {
      WebkitLineClamp: lines
    }
  }, text), isExceedingMaxLines() && detailText && !showMore && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(textClassName, " ").concat(classes.detailText)
  }, detailText), isExceedingMaxLines() && /*#__PURE__*/_react.default.createElement("input", {
    type: "button",
    className: classes.link,
    value: !showMore ? 'ver mais' : 'ver menos',
    onClick: () => setShowMore(!showMore)
  }));
};
ReadMoreText.propTypes = {
  text: _propTypes.default.string.isRequired,
  textClassName: _propTypes.default.string,
  detailText: _propTypes.default.string,
  lines: _propTypes.default.number
};
ReadMoreText.defaultProps = {
  textClassName: null,
  detailText: null,
  lines: 1
};
var _default = exports.default = ReadMoreText;